import { render } from "./ProductCardPreview.vue?vue&type=template&id=44a9a424"
import script from "./ProductCardPreview.vue?vue&type=script&lang=js"
export * from "./ProductCardPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__